import { render, staticRenderFns } from "./SelectQuantityRegister.vue?vue&type=template&id=0b67d6fc&scoped=true&"
import script from "./SelectQuantityRegister.vue?vue&type=script&lang=js&"
export * from "./SelectQuantityRegister.vue?vue&type=script&lang=js&"
import style0 from "@/assets/scss/common/select-quantity/select-quantity-register.scss?vue&type=style&index=0&id=0b67d6fc&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b67d6fc",
  null
  
)

export default component.exports